// 中英文关联关键词
import request from '@/utils/request'

// 生产环境api路径

export function searchCoreKeywordsv2 (data) {
  return request({
    data: data,
    url: '/old/searchCoreKeywordsv2',
    method: 'post'
  })
}
export function getKeywordTranslate (data) {
  return request({
    data: data,
    url: '/old/keywordTranslate',
    method: 'post'
  })
}
export function searchSCI (data) {
  return request({
    data: data,
    url: '/old/searchCoreKeywordsBySCI',
    method: 'post'
  })
}

// 开发环境api路径

// export function searchCoreKeywordsv2 (data) {
//   return request({
//     data: data,
//     url: 'api/searchCoreKeywordsv2',
//     method: 'post'
//   })
// }
// export function searchSCI (data) {
//   return request({
//     data: data,
//     url: 'api/searchCoreKeywordsBySCI',
//     method: 'post'
//   })
// }

// export function getKeywordTranslate (data) {
//   return request({
//     data: data,
//     url: 'api/keywordTranslate',
//     method: 'post'
//   })
// }



// WEBPACK FOOTER //
// ./src/api/contrast.js